// extracted by mini-css-extract-plugin
export default {"video-link":"n_bs d-flex align-items-center my-2","video-link__link":"n_bt ml-2"};